export default [{
    'id': 'Ad001',
    'name': '1 号广告位',
    'lng': 118.04228378983412,
    'lat': 24.614540335739587,
    'height': 19.78697627497943,
    'pictures': ['../data/adPictures/1/1.jpg', '../data/adPictures/1/2.jpg', '../data/adPictures/1/3.png', '../data/adPictures/1/4.jpg', '../data/adPictures/1/5.jpg', '../data/adPictures/1/6.jpg', '../data/adPictures/1/7.jpg'],
    'price': '76 元/天',
    'dealTime': '2021-05-30'
}, {
    'id': 'Ad002',
    'name': '2 号广告位',
    'lng': 118.04122140226836,
    'lat': 24.61662781570861,
    'height': 21.135226161490852,
    'pictures': ['../data/adPictures/2/1.jpg', '../data/adPictures/2/2.jpg', '../data/adPictures/2/3.jpg', '../data/adPictures/2/4.jpg', '../data/adPictures/2/5.jpg'],
    'price': '98 元/天',
    'dealTime': '2021-08-30'
}, {
    'id': 'Ad003',
    'name': '3 号广告位',
    'lng': 118.04095376627252,
    'lat': 24.61630394613763,
    'height': 21.133218688811116,
    'pictures': ['../data/adPictures/3/1.jpg', '../data/adPictures/3/2.jpg', '../data/adPictures/3/3.jpg', '../data/adPictures/3/4.jpg', '../data/adPictures/3/5.jpg', '../data/adPictures/3/6.jpg'],
    'price': '50 元/天',
    'dealTime': '2021-08-30'
}, {
    'id': 'Ad004',
    'name': '4 号广告位',
    'lng': 118.04008871779041,
    'lat': 24.615905062917456,
    'height': 22.350717537094518,
    'pictures': ['../data/adPictures/4/1.jpg', '../data/adPictures/4/2.jpg', '../data/adPictures/4/3.jpg', '../data/adPictures/4/4.jpg'],
    'price': '59 元/天',
    'dealTime': '2021-04-30'
}, {
    'id': 'Ad005',
    'name': '5 号广告位',
    'lng': 118.0403964235278,
    'lat': 24.614927120861665,
    'height': 22.52283174626319,
    'pictures': ['../data/adPictures/3/1.jpg', '../data/adPictures/3/2.jpg', '../data/adPictures/3/3.jpg', '../data/adPictures/3/4.jpg', '../data/adPictures/3/5.jpg', '../data/adPictures/3/6.jpg'],
    'price': '76 元/天',
    'dealTime': '2021-07-30'
}, {
    'id': 'Ad006',
    'name': '6 号广告位',
    'lng': 118.04001336132181,
    'lat': 24.615157676910506,
    'height': 23.12487476777741,
    'pictures': ['../data/adPictures/3/1.jpg', '../data/adPictures/3/2.jpg', '../data/adPictures/3/3.jpg', '../data/adPictures/3/4.jpg', '../data/adPictures/3/5.jpg', '../data/adPictures/3/6.jpg'],
    'price': '90 元/天',
    'dealTime': '2021-02-30'
}, {
    'id': 'Ad007',
    'name': '7 号广告位',
    'lng': 118.03925017455482,
    'lat': 24.618188367172873,
    'height': 23.555191357922464,
    'pictures': ['../data/adPictures/2/1.jpg', '../data/adPictures/2/2.jpg', '../data/adPictures/2/3.jpg', '../data/adPictures/2/4.jpg', '../data/adPictures/2/5.jpg'],
    'price': '88 元/天',
    'dealTime': '2021-08-30'
}, {
    'id': 'Ad008',
    'name': '8 号广告位',
    'lng': 118.04172104796365,
    'lat': 24.615956324741,
    'height': 20.685010003473444,
    'pictures': ['../data/adPictures/4/1.jpg', '../data/adPictures/4/2.jpg', '../data/adPictures/4/3.jpg', '../data/adPictures/4/4.jpg'],
    'price': '96 元/天',
    'dealTime': '2021-06-30'
}, {
    'id': 'Ad009',
    'name': '9 号广告位',
    'lng': 118.04171960624002,
    'lat': 24.616931060455325,
    'height': 18.79518131350649,
    'pictures': ['../data/adPictures/1/1.jpg', '../data/adPictures/1/2.jpg', '../data/adPictures/1/3.png', '../data/adPictures/1/4.jpg', '../data/adPictures/1/5.jpg', '../data/adPictures/1/6.jpg', '../data/adPictures/1/7.jpg'],
    'price': '95 元/天',
    'dealTime': '2021-03-30'
}, {
    'id': 'Ad010',
    'name': '10 号广告位',
    'lng': 118.04128903725714,
    'lat': 24.6135830496961,
    'height': 28.75922040526,
    'pictures': ['../data/adPictures/4/1.jpg', '../data/adPictures/4/2.jpg', '../data/adPictures/4/3.jpg', '../data/adPictures/4/4.jpg'],
    'price': '67 元/天',
    'dealTime': '2021-07-30'
}, {
    'id': 'Ad011',
    'name': '11 号广告位',
    'lng': 118.04318382464834,
    'lat': 24.61313747819693,
    'height': 17.67121699830401,
    'pictures': ['../data/adPictures/2/1.jpg', '../data/adPictures/2/2.jpg', '../data/adPictures/2/3.jpg', '../data/adPictures/2/4.jpg', '../data/adPictures/2/5.jpg'],
    'price': '94 元/天',
    'dealTime': '2021-09-30'
}, {
    'id': 'Ad012',
    'name': '12 号广告位',
    'lng': 118.04415974295917,
    'lat': 24.615571577108803,
    'height': 15.276382208429508,
    'pictures': ['../data/adPictures/1/1.jpg', '../data/adPictures/1/2.jpg', '../data/adPictures/1/3.png', '../data/adPictures/1/4.jpg', '../data/adPictures/1/5.jpg', '../data/adPictures/1/6.jpg', '../data/adPictures/1/7.jpg'],
    'price': '96 元/天',
    'dealTime': '2021-08-30'
}, {
    'id': 'Ad013',
    'name': '13 号广告位',
    'lng': 118.0452126994096,
    'lat': 24.61413109034865,
    'height': 16.172668711994465,
    'pictures': ['../data/adPictures/1/1.jpg', '../data/adPictures/1/2.jpg', '../data/adPictures/1/3.png', '../data/adPictures/1/4.jpg', '../data/adPictures/1/5.jpg', '../data/adPictures/1/6.jpg', '../data/adPictures/1/7.jpg'],
    'price': '58 元/天',
    'dealTime': '2021-03-30'
}, {
    'id': 'Ad014',
    'name': '14 号广告位',
    'lng': 118.04427137808196,
    'lat': 24.61358111017344,
    'height': 17.1494670426167,
    'pictures': ['../data/adPictures/2/1.jpg', '../data/adPictures/2/2.jpg', '../data/adPictures/2/3.jpg', '../data/adPictures/2/4.jpg', '../data/adPictures/2/5.jpg'],
    'price': '64 元/天',
    'dealTime': '2021-09-30'
}];